import {Component, Inject, OnInit} from '@angular/core';
import {FiltersCheckResult} from "../../core/state/core.state";
import {takeUntil} from "rxjs/operators";
import {Store} from "@ngxs/store";
import {Subject} from "rxjs/index";
import {CheckFilters} from "../../core/state/core.actions";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-check-filters-dialog',
  templateUrl: './check-filters-dialog.component.html',
  styleUrls: ['./check-filters-dialog.component.scss']
})
export class CheckFiltersDialogComponent implements OnInit {
  // destroyed$ = new Subject();

  // public filters;
  public syntaxCorrect: boolean = false;
  public logicCorrect: boolean = false;
  public checkResult: FiltersCheckResult = {total: 0, text: '', checked: false};
  public tooltip: string = '';

  constructor(private store: Store,
              private dialogRef: MatDialogRef<CheckFiltersDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any) {
    // this.filters = data.filters;
  }

  ngOnInit(): void {
    // this.store.select((s) => s.core.checkFiltersResult).pipe(
    //   takeUntil(this.destroyed$)
    // ).subscribe(
    //   (v: FiltersCheckResult) => {
    //     if(v) {
    //       this.filtersCheckResult = v;
    //       this.logicCorrect = this.filters.length == 0 || v.total > 0;
    //     }
    // });
    //
    // this.check();
  }

  // ngOnDestroy(): void {
  //   this.destroyed$.next();
  //   this.destroyed$.complete();
  // }

  // check() {
  //   let bracketsCorrect = this.checkBrackets();
  //   let operationsCorrect = false;
  //   if (bracketsCorrect) {
  //     operationsCorrect = this.checkOperations();
  //
  //   }
  //
  //   this.syntaxCorrect = bracketsCorrect && operationsCorrect;
  //   if (!bracketsCorrect) {
  //     this.tooltip = 'Ошибка с расстановкой скобок';
  //   } else if (!operationsCorrect) {
  //     this.tooltip = 'Ошибка с логическими операторами';
  //   } else {
  //     this.tooltip = 'Ошибок в синтаксисе нет';
  //   }
  //   this.checkUnions();
  // }
  //
  // checkBrackets() : boolean {
  //   const brackets = this.filters.filter(f => f.t == 'op' && ['(', ')'].includes(f.v)).map(f => f.v);
  //   let sum = 0;
  //   for (let i=0 ; i<brackets.length ; i++) {
  //     sum += brackets[i] == '(' ? 1 : -1;
  //     if (sum < 0) {
  //       return false;
  //     }
  //   }
  //   return sum == 0;
  // }
  //
  // checkOperations() : boolean {
  //   let el = '';
  //   let prev = '';
  //   for (let i=0 ; i<this.filters.length ; i++) {
  //     // const f = this.filterFields[i];
  //     el = this.filters[i].t == 'op' ? this.filters[i].v : 'block';
  //
  //     if (i == 0) {
  //       // первым можно только NOT, ( или блок
  //       if ( ! ['NOT', '(', 'block'].includes(el)) {
  //         console.log(i, prev, el, 'первым можно только NOT, ( или блок');
  //         return false;
  //       }
  //     } else {
  //
  //       // две подряд операции нельзя за исключением, когда после операции идет NOT или (
  //       if (['AND', 'OR',].includes(el) && ['AND', 'OR',].includes(prev)) {
  //         console.log(i, prev, el, 'две подряд операции нельзя за исключением, когда после операции идет NOT или (');
  //         return false;
  //       }
  //
  //       // два подряд NOT нельзя
  //       if (el == 'NOT' && prev == 'NOT') {
  //         console.log(i, prev, el, 'два подряд NOT нельзя');
  //         return false;
  //       }
  //
  //       // два подряд блока нельзя
  //       if (el == 'block' && prev == 'block') {
  //         console.log(i, prev, el, 'два подряд блока нельзя');
  //         return false;
  //       }
  //
  //       // должен быть блок перед закрывающей скобкой
  //       if (el == ')' && prev != 'block') {
  //         console.log(i, prev, el, 'должен быть блок перед закрывающей скобкой');
  //         return false;
  //       }
  //
  //       // после открывающей скобки можно только NOT или блок
  //       if (prev == '(' && ! ['NOT', 'block'].includes(el) ) {
  //         console.log(i, prev, el, ' после открывающей скобки можно только NOT или блок');
  //         return false;
  //       }
  //
  //     }
  //
  //     prev = el;
  //   }
  //   return true;
  // }
  //
  // checkUnions() {
  //   if(this.filters.length > 0) {
  //     this.store.dispatch(
  //       new CheckFilters(this.filters)
  //     );
  //   } else {
  //     this.logicCorrect = true;
  //   }
  // }

  close() {
    this.dialogRef.close();
  }
}
